module.exports = __webpack_public_path__ + "static/media/rabbitmq.d26614b8.svg";